// TODO (anniew|TREET-2191) Share Uploadcare code in server and src

export enum ImageSource {
  Uploadcare = 'UPLOADCARE',
}

export const isUploadcareImage = (src: string) => src.includes('ucarecdn.com/');

// Used for listing image displays
export const formatUploadcareImageForDisplay = (
  cdnUrl?: string,
  smartResizeImageRatio?: number, // Only usually used when you want to apply a background color
  bgColor?: string
): string | null => {
  if (!cdnUrl) return null;
  if (!isUploadcareImage(cdnUrl)) return cdnUrl;

  let previewUrl = cdnUrl;

  // Remove any existing resize, smart_resize, setfill, or format params
  previewUrl = previewUrl.replace(/(-\/(resize|smart_resize|setfill|format)\/[^/]*\/?)+/g, '');

  const defaultResize = 500;

  if (smartResizeImageRatio) {
    const width = defaultResize;
    const height = width * smartResizeImageRatio;
    previewUrl = previewUrl.concat(`-/smart_resize/${width}x${height}/`);
  } else {
    previewUrl = previewUrl.concat(`-/resize/${defaultResize}x/`);
  }

  if (bgColor) {
    previewUrl = previewUrl
      // Needs to be jpeg in order to use fill
      .concat(`-/setfill/${bgColor}/-/format/jpeg/`);
  } else {
    // Use Uploadcare's default formatting which will pick the best format for the image for performance
    previewUrl = previewUrl.concat('-/format/auto/');
  }

  return previewUrl;
};

// Used for PDP
export const getLargeUploadcareImagePreviewUrl = (cdnUrl?: string): string | null => {
  if (!cdnUrl) return null;
  if (!isUploadcareImage(cdnUrl)) return cdnUrl;

  let previewUrl = cdnUrl;
  if (!cdnUrl.includes('-/resize/2000x/')) {
    previewUrl = previewUrl.concat('-/resize/2000x/');
  }

  if (!cdnUrl.includes('-/quality/lightest/')) {
    previewUrl = previewUrl.concat('-/quality/lightest/');
  }

  if (!cdnUrl.includes('-/progressive/yes/')) {
    previewUrl = previewUrl.concat('-/progressive/yes/');
  }

  if (!cdnUrl.includes('-/format/auto/')) {
    previewUrl = previewUrl.concat('-/format/auto/');
  }

  return previewUrl;
};

// Fetching a really small thumbnail just to check if the image is transparent. Should not be used for anything else.
export const getSmallUploadcarePreviewAsPng = (cdnUrl?: string): string | null => {
  if (!cdnUrl) return null;
  if (!isUploadcareImage(cdnUrl)) return cdnUrl;

  let previewUrl = cdnUrl;
  if (!cdnUrl.includes('-/resize/100x/')) {
    previewUrl = previewUrl.concat('-/resize/100x/');
  }

  if (!cdnUrl.includes('-/format/png/')) {
    previewUrl = previewUrl.concat('-/format/png/');
  }

  return previewUrl;
};
